import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import { Guid } from "guid-typescript";
import simplebar from "simplebar-vue";
import { ProjectModule } from "@/store/modules/project.module";
//SYSTEM
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import CredMixer from "@/router/views/CredMixer";
import { PMOTaskCreationModel } from "@/store/models/project/PMOTaskCreation";
import { toaster } from "@/utilities/toaster";
import projectDetailMachine from "./machines/projectOverViewMachine";
import { interpret } from "xstate";
import { ProjectMemberCreationModel } from "@/store/models/project/projectMemberCreation";
import Swal from "sweetalert2";
import { SubProjectsUnderParentProjectModel } from "@/store/models/project/subProjectsUnderParentProjectDTO";
import { LinkSubprojectToProjectModel } from "@/store/models/project/linkSubprojectToProject";
import EmployeeUserComponent from "./components/EmployeeUserComponent.vue";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { ProjectFilesStorageModel } from "@/store/models/project/ProjectFilesStorage";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { ProjectTaskViewModel } from "@/store/models/project/projectTaskViewDTO";
import { PMOConvertTaskToProjectModel } from "@/store/models/project/convertTaskToProject";
import ProjectImpedimentComponent from "./components/ProjectImpedimentComponent.vue";
import { bus } from "@/main";
import SkeletonLoaderProjectOverview from "@/components/SkeletonLoaderProjectOverview.vue";
import MultiSelectComponent from "@/components/widgets/MultiSelectComponent.vue";
Component.registerHooks(["metaInfo"]);
let ProjectOverview = /** @class */ (() => {
    let ProjectOverview = class ProjectOverview extends Mixins(BaseMixer, CredMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Project Overview";
            this.createTask = false;
            this.addMember = false;
            this.projectName = "";
            this.task = new PMOTaskCreationModel();
            this.editTasks = new ProjectTaskViewModel();
            this.project = new SubProjectsUnderParentProjectModel();
            this.projectImpediments = false;
            this.memberModal = false;
            this.projectMember = new ProjectMemberCreationModel();
            this.isAssignMode = true;
            this.manageAssignedTags = true;
            this.applyToAllSubProjects = false;
            this.canUnassignFromAllSubProjects = false;
            this.tagsToAssign = [];
            this.assignedTags = [];
            this.inheritedTags = [];
            // public parentProject:PMOParentProjectModel = new PMOParentProjectModel();
            this.linkProject = new LinkSubprojectToProjectModel();
            this.link = new ProjectFilesStorageModel();
            this.machine = projectDetailMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "PMO",
                    href: "#",
                },
                {
                    text: "Projects",
                    to: "/projects",
                },
                {
                    text: "Project Overview",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "Projects",
                },
            ];
            this.showMemberList = false;
            this.EditProject = false;
            this.searchKey = "";
            this.selectedProjectTask = new PMOConvertTaskToProjectModel();
            this.selectedProject = new PMOConvertTaskToProjectModel();
            this.convertedSubProjectName = "";
            this.projectDetailNotes = "";
            this.filteredUsers = [];
            this.selectedUser = null;
            this.requestedUser = null;
            this.filteredProjects = [];
            this.selectedOwnedProject = null;
            this.disableRadioButton = false;
            this.projectDetail = [];
            this.taskDetail = [];
            this.titleContent = "Task Owner";
        }
        send(event) {
            this.machineService.send(event);
        }
        confirmRemoveMember(employeeId) {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                title: `Are you sure, you want to remove this member?`,
                text: `You won't be able to revert this!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    this.send({
                        type: "REMOVE_MEMBER_FROM_PROJECT",
                        employeeId: employeeId,
                    });
                }
            });
        }
        ShowConvertToProjectModal(task) {
            this.projectDetail = [];
            this.taskDetail = [];
            if (task.createdBy == this.projectDetailEntries.ownedBy) {
                this.taskDetail.push({ id: task.createdBy, name: task.fullName, isOwner: true });
                this.selectedProject.projectOwnerId = task.createdBy;
                this.disableRadioButton = true;
            }
            else {
                this.taskDetail.push({ id: task.createdBy, name: task.fullName, isOwner: true });
                this.projectDetail.push({ id: this.projectDetailEntries.ownedBy.toString(), name: this.projectOwner.fullName });
                this.selectedProject.projectOwnerId = task.createdBy;
                this.disableRadioButton = false;
            }
            if (task.isDefaultTask) {
                this.$bvModal.show("Restrict-Convert-Task-To-Project");
            }
            else {
                this.selectedProject.taskName = task.name;
                this.selectedProject.taskDescription = task.description;
                this.selectedProject.projectName = task.name;
                this.selectedProject.projectDescription = task.description;
                this.selectedProject.taskId = task.id;
                this.selectedProject.projectId = this.projectDetailEntries.id;
                this.convertedSubProjectName = `${this.projectDetailEntries.name} > ${task.name}`;
                this.send({ type: "CONVERT_TASK_TO_PROJECT" });
            }
        }
        CancelConvertToProject() {
            this.send({ type: "CLOSE_MODAL" });
        }
        convertTaskToProject() {
            this.validate("ConvertTaskToProject").then((response) => {
                if (response) {
                    if (this.selectedProject.isMainProject == true) {
                        this.send({
                            type: "CONVERTING_TASK_TO_PROJECT",
                            payload: this.selectedProject,
                        });
                        this.send({ type: "CLOSE_MODAL" });
                    }
                    else {
                        if (this.selectedProject.isMainProject == false) {
                            this.selectedProject.projectName = this.convertedSubProjectName;
                            this.send({
                                type: "CONVERTING_TASK_TO_PROJECT",
                                payload: this.selectedProject,
                            });
                        }
                        this.send({ type: "CLOSE_MODAL" });
                    }
                }
            });
        }
        closeConvertToProjectModal() {
            this.selectedProject.isMainProject = true;
            // this.projectAndTaskDetail = [];
            this.projectDetail = [];
            this.taskDetail = [];
            this.selectedProject.projectOwnerId = "";
            this.send({ type: "CLOSE_MODAL" });
        }
        closeAssignedTagsDrawer() {
            var assignedTagsDrawer = this.$refs["assigned-tags-drawer"];
            assignedTagsDrawer.isShow = false;
        }
        closeInheritedTagsDrawer() {
            var inheritedTagsDrawer = this.$refs["inherited-tags-drawer"];
            inheritedTagsDrawer.isShow = false;
        }
        //new implementation
        get isPerformingTagOperation() {
            return this.state.matches("assigningTag") || this.state.matches("unassigningTag");
        }
        get projectDetailEntries() {
            return ProjectModule.projectDetailEntries;
        }
        get sortedMembersForOwner() {
            return _.sortBy(ProjectModule.projectDetailEntries.members, (item) => item.fullName);
        }
        get membersForOwner() {
            return this.sortedMembersForOwner.filter((x) => x.employeeId != this.projectDetailEntries.ownedBy && x.isActiveMember);
        }
        get projectsUrl() {
            return ProjectModule.projectsUrlStorage;
        }
        get sortedTasks() {
            return _.sortBy(this.projectDetailEntries.tasks, (item) => item.createdOn).reverse();
        }
        get members() {
            return ProjectModule.projectMemberEntries;
        }
        get users() {
            return ProjectModule.usersForParentProject;
        }
        get projectOwner() {
            return ProjectModule.projectDetailEntries?.members?.find((x) => x.employeeId == ProjectModule.projectDetailEntries.ownedBy);
        }
        get isProjectOwner() {
            return this.projectDetailEntries?.isProjectOwner ?? false;
        }
        get subProjects() {
            return ProjectModule.subProjects;
        }
        get tags() {
            return ProjectModule.tags;
        }
        get projectTags() {
            return ProjectModule.projectTags;
        }
        get availableTags() {
            let _tags = this.tags?.map((x) => ({ id: x.id, value: x.name, code: x.color, isSelected: true })) ?? [];
            if (this.hasProjectTags) {
                this.assignedTags = this.projectTags.filter((x) => x.isInherited == false).map((x) => ({ id: x.tagId, value: x.tagName, code: x.tagColor, isSelected: true })) ?? [];
                this.inheritedTags = this.projectTags.filter((x) => x.isInherited == true).map((x) => ({ id: x.tagId, value: x.tagName, code: x.tagColor, isSelected: true })) ?? [];
                _tags = _tags.filter((tag) => !this.assignedTags.some((assignedTag) => assignedTag.id === tag.id));
            }
            else {
                this.assignedTags = [];
                this.inheritedTags = [];
            }
            if (this.hasTagsToAssign) {
                _tags = _tags.filter((tag) => !this.tagsToAssign.some((selected) => selected.id === tag.id));
            }
            return _tags;
        }
        get hasTags() {
            return this.tags && this.tags.length > 0;
        }
        get hasProjectTags() {
            return this.projectTags && this.projectTags.length > 0;
        }
        get hasAvailableTags() {
            return this.availableTags && this.availableTags.length > 0;
        }
        get hasTagsToAssign() {
            return this.tagsToAssign && this.tagsToAssign.length > 0;
        }
        get hasAssignedTags() {
            return this.assignedTags && this.assignedTags.length > 0;
        }
        get hasInheritedTags() {
            return this.inheritedTags && this.inheritedTags.length > 0;
        }
        get canAddTag() {
            return this.isTeamLead && this.hasAvailableTags;
        }
        get canDeleteTag() {
            return this.isTeamLead;
        }
        get sortedSubProjects() {
            return _.sortBy(this.subProjects, (item) => item.createdOn).reverse();
        }
        get ownedProjects() {
            return ProjectModule.ownedProjects;
        }
        get parentProject() {
            return ProjectModule.parentProject;
        }
        get projectTotalTimeSpent() {
            if (this.projectDetailEntries.timeSpent > 0) {
                let value = this.projectDetailEntries.timeSpent / 60;
                let hours = Math.floor(value / 60);
                let minutes = value % 60;
                let formattedMinutes = minutes.toFixed(0);
                return hours + "Hrs " + formattedMinutes + "m";
            }
            return 0 + "Hr " + 0 + "m";
        }
        get checkMNCO() {
            return ClockWorkModule.clockWorkNullEntries.length > 0;
        }
        get isSkeletonLoading() {
            return this.state.matches("gettingDetails.gettingProjectDetails");
        }
        showEditProject() {
            this.machineService.send({ type: "UPDATE_PROJECT" });
        }
        markAsApexProject() {
            this.projectId = Guid.parse(this.$route.params.projectId);
            this.machineService.send({ type: "MARK_AS_APEX_PROJECT", projectId: this.projectId });
        }
        markAsApexSubProject(subProjectId) {
            this.machineService.send({ type: "MARK_AS_APEX_SUB_PROJECT", projectId: subProjectId });
        }
        removeAsApexProject() {
            this.projectId = Guid.parse(this.$route.params.projectId);
            this.machineService.send({ type: "REMOVE_AS_APEX_PROJECT", projectId: this.projectId });
        }
        removeAsApexSubProject(subProjectId) {
            this.machineService.send({ type: "REMOVE_AS_APEX_SUB_PROJECT", projectId: subProjectId });
        }
        showCreateTaskModal() {
            this.machineService.send({ type: "CREATE_TASK" });
        }
        openAddMemberModal() {
            this.machineService.send({ type: "ADD_MEMBER" });
        }
        closeEditProjectModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        createTaskUnderProject() {
            this.validate("createTaskObserver").then((res) => {
                if (res) {
                    this.task.projectId = this.projectDetailEntries.id.toString();
                    this.machineService.send({ type: "SAVING_TASK", payload: this.task });
                }
            });
        }
        addMemberToProject() {
            this.projectMember.projectId = this.projectId.value;
            this.machineService.send({
                type: "SAVING_MEMBER",
                member: this.projectMember,
            });
            this.searchKey = "";
            this.projectMember = {
                projectId: null,
                employeeId: null,
            };
        }
        cancelCreateTaskModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
            this.task = {
                projectId: null,
                taskName: null,
                taskDescription: null,
            };
        }
        cancelAddMemberModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        //change OwnerShip
        showChangeOwnerShipModal() {
            this.employeeId = Guid.createEmpty();
            this.machineService.send({ type: "CHANGE_OWNERSHIP" });
        }
        makeOwner() {
            this.validate("changeOwnerShipObserver").then((res) => {
                if (res) {
                    this.machineService.send({
                        type: "SAVING_OWNERSHIP",
                        employeeId: this.employeeId,
                    });
                    this.employeeId = Guid.createEmpty();
                }
            });
        }
        cancelOwner() {
            this.employeeId = Guid.createEmpty();
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        // Link Project
        showUsersModal() {
            this.ClearSelectedUser();
            this.machineService.send({ type: "REQUEST_FOR_USERS" });
        }
        SelectedUser(user) {
            this.selectedUser = Object.assign({}, user);
            this.searchKey = "";
        }
        sendNotificationForParentProjects() {
            this.validate("employeeUserObserver").then((res) => {
                if (res) {
                    this.projectId = Guid.parse(this.$route.params.projectId);
                    this.requestedUser = {
                        employeeId: this.selectedUser.employeeId,
                        projectId: this.projectId.value,
                        projectDetailNotes: this.projectDetailNotes,
                    };
                    this.machineService.send({
                        type: "REQUESTING_USER",
                        payload: this.requestedUser,
                    });
                    ProjectModule.clearUser();
                }
            });
        }
        CancelRequest() {
            this.ClearSelectedUser();
            this.ClearSearchedDetailsForUser();
            ProjectModule.clearUser();
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        searchUser() {
            this.filteredUsers = this.users.filter((item) => item.fullName.toLowerCase().includes(this.searchKey.toLowerCase()));
            if (this.SelectedUser != null) {
                this.ClearSelectedUser();
            }
            if (this.searchKey == "" || this.searchKey == null) {
                this.ClearSelectedUser();
                this.filteredUsers = [];
            }
        }
        ClearSearchedDetailsForUser() {
            this.filteredUsers = [];
            this.searchKey = "";
            this.projectDetailNotes = "";
            this.requestedUser = null;
        }
        ClearSelectedUser() {
            this.selectedUser = null;
        }
        updateProject() {
            this.validate("editProject").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "UPDATING_PROJECT",
                        payload: this.projectDetailEntries,
                    });
                }
            });
        }
        editTask(taskId) {
            for (var i = 0; i < ProjectModule.projectDetailEntries.tasks.length; i++) {
                if (ProjectModule.projectDetailEntries.tasks[i].id == taskId) {
                    this.editTasks = ProjectModule.projectDetailEntries.tasks[i];
                }
            }
            this.machineService.send({ type: "EDIT_TASK" });
        }
        updateTask() {
            this.validate("editTask").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "UPDATE_TASK",
                        payLoad: this.editTasks,
                    });
                }
            });
        }
        closeEditTaskModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        closeDeleteTaskModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        closeAddSubProjectModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        resetTagOperation() {
            this.tagsToAssign = [];
            this.canUnassignFromAllSubProjects = true;
            this.applyToAllSubProjects = false;
        }
        tagOperationPerformed() {
            toaster.ShowSuccess(`Tag(s) ${this.isAssignMode ? "assigned to" : "unassigned from"} this project ${this.applyToAllSubProjects ? "and all its sub projects" : ""} successfully!`);
        }
        checkTagCanUnassignFromAllSubProjects(tagId) {
            return this.projectTags.find((pt) => pt.tagId === tagId)?.assignedToAll ?? true;
        }
        onPerformingTagOperation(item) {
            this.resetTagOperation();
            if (item) {
                this.tagsToAssign = [
                    {
                        id: item.id,
                        value: item.value,
                        code: item.code,
                        isSelected: true,
                    },
                ];
                this.canUnassignFromAllSubProjects = this.checkTagCanUnassignFromAllSubProjects(item.id);
            }
            this.machineService.send({ type: this.isAssignMode ? "ASSIGN_TAG" : "UNASSIGN_TAG" });
        }
        manageTags(manageAssignedTags, isAssignMode) {
            this.manageAssignedTags = manageAssignedTags;
            this.isAssignMode = isAssignMode;
            this.onPerformingTagOperation();
        }
        onAssigningTag(item) {
            this.isAssignMode = true;
            this.onPerformingTagOperation(item);
        }
        onUnassigningTag(item) {
            this.isAssignMode = false;
            this.onPerformingTagOperation(item);
        }
        manageTag() {
            const payload = {
                tagIds: this.tagsToAssign.map((tag) => tag.id),
                applyToAllSubProjects: this.applyToAllSubProjects,
                isAssignOperation: this.isAssignMode,
            };
            this.machineService.send({ type: this.isAssignMode ? "ASSIGNING_TAG" : "UNASSIGNING_TAG", payload: payload });
        }
        closeManageTagModal() {
            this.resetTagOperation();
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        deleteTask(taskId) {
            this.machineService.machine.context.taskId = taskId;
            this.machineService.send({ type: "DELETE_TASK" });
        }
        startEntry(taskId, taskName) {
            if (this.checkMNCO) {
                return;
            }
            this.machineService.send({
                type: "ADD_ENTRY_UNDER_TASK",
                taskId: taskId,
                taskName: taskName,
            });
        }
        confirmDelete() {
            this.machineService.send({ type: "DELETING_TASK" });
        }
        showLinkModal() {
            this.machineService.send({
                type: "LINK_WITH_PARENT_PROJECT",
                projectId: this.projectId,
            });
        }
        searchProject() {
            this.filteredProjects = this.ownedProjects.filter((item) => item.name.toLowerCase().includes(this.searchKey.toLowerCase()) || item.code.toPrecision().includes(this.searchKey.toLowerCase()) || item.code.toString().includes(this.searchKey.toLowerCase()));
            this.filteredProjects.sort((a, b) => a.code - b.code);
            if (this.selectedOwnedProject != null) {
                this.ClearSelectedProject();
            }
            if (this.searchKey === "" || this.searchKey === null) {
                this.filteredProjects = [];
                this.ClearSelectedProject();
            }
        }
        SelectedOwnedProject(project) {
            this.selectedOwnedProject = Object.assign({}, project);
            this.searchKey = "";
        }
        closeLinkModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
            this.ClearSearchedProject();
            this.ClearSelectedProject();
            ProjectModule.clearProject();
        }
        ClearSelectedProject() {
            this.selectedOwnedProject = null;
        }
        ClearSearchedProject() {
            this.searchKey = "";
            this.filteredProjects = [];
        }
        linkingProjectWithOwnedProject() {
            this.validate("linkWithParentOwnedProject").then((response) => {
                if (response) {
                    // this.projectDetailEntries.isAccepted = true;
                    this.projectId = Guid.parse(this.$route.params.projectId);
                    this.linkProject.projectId = this.selectedOwnedProject.id.toString();
                    this.linkProject.subProjectId = this.projectId.value;
                    this.linkProject.employeeId = this.projectOwner.employeeId.toString();
                    this.machineService.send({
                        type: "LINKING_PROJECT",
                        payLoad: this.linkProject,
                    });
                    ProjectModule.clearProject();
                }
            });
        }
        showSubProjectModal() {
            this.machineService.send({ type: "ADD_SUBPROJECT" });
        }
        showprojectImpedimentsModal() {
            let projectImpediments = this.$refs["projectImpedimentRef"];
            projectImpediments.showModal();
        }
        //Lifecycle;
        saveSubProject() {
            this.validate("createSubProjectObserver").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "ADDING_SUBPROJECT",
                        payload: this.project,
                    });
                }
            });
        }
        showSubProjectDeleteModal(projectId) {
            this.subProjectId = projectId;
            this.machineService.send({ type: "DELETE_SUB_PROJECT" });
        }
        cancelDeleteSubProject() {
            this.subProjectId = null;
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        deleteSubProject() {
            this.machineService.send({ type: "DELETING_SUB_PROJECT", projectId: this.subProjectId });
        }
        cancelProject() {
            this.project.name = "";
            this.project.description = "";
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        deLinkSubProject() {
            this.machineService.send({ type: "DELINKING_SUB_PROJECT", projectId: this.subProjectId });
        }
        canceldeLinkSubProject() {
            this.subProjectId = null;
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        showSubProjectDeLinkModal(projectId) {
            this.subProjectId = projectId;
            this.machineService.send({ type: "DELINK_SUB_PROJECT" });
        }
        ShowAddLinksModal() {
            this.machineService.send({ type: "ADD_LINK" });
        }
        handlerUrlClick(url) {
            var valid = /^(ftp|http|https):\/\/[^ "]+$/.test(url);
            if (valid == true) {
                window.open(url, "_blank");
            }
            else {
                toaster.ShowError("Please provide a valid link.");
            }
        }
        ShowEditLinkModal(id) {
            for (var i = 0; i < ProjectModule.projectsUrlStorage.length; i++) {
                if (ProjectModule.projectsUrlStorage[i].id == id) {
                    this.editFileLink = ProjectModule.projectsUrlStorage[i];
                }
            }
            this.machineService.send({ type: "EDIT_LINK" });
        }
        closeUrlModal() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        ShowDeleteLinkModal(linkId) {
            this.machineService.machine.context.linkId = linkId;
            this.machineService.send({ type: "DELETE_LINK" });
        }
        saveLink() {
            this.validate("addLink").then((response) => {
                if (response) {
                    this.machineService.send({ type: "SAVE_LINK", link: this.link });
                }
            });
        }
        UpdateLink() {
            this.validate("editLink").then((response) => {
                if (response) {
                    this.machineService.send({
                        type: "UPDATE_LINK",
                        editFileLink: this.editFileLink,
                    });
                }
            });
        }
        DeleteLink() {
            this.machineService.send({ type: "DELETING_LINK" });
        }
        addProjectToWatchList() {
            if (!this.projectDetailEntries.isWatching) {
                this.machineService.send({ type: "ADDING_PROJECT_TO_WATCHLIST" });
            }
            else {
                this.machineService.send({ type: "REMOVING_PROJECT_FROM_WATCHLIST" });
            }
        }
        goToProjectAnalytics() {
            this.$router.push({ name: "ProjectAnalytics" });
        }
        goToProjectOverView(projectId, isViewable) {
            if (projectId != null) {
                if (isViewable) {
                    this.$router.push({ name: "ProjectOverview", params: { projectId: projectId } });
                }
                else {
                    Swal.fire({
                        text: "Sorry! You do not have access to view this Project.",
                        icon: "warning",
                        confirmButtonColor: "#34c38f",
                        confirmButtonText: "Okay",
                    }).then(() => { });
                }
            }
        }
        ShowProjectListForMoveToTask(taskId, taskOwnerId) {
            this.ClearSelectedProject();
            this.taskId = taskId;
            this.projectId = Guid.parse(this.$route.params.projectId);
            this.machineService.send({ type: "GETTING_OWNED_PROJECTS", userId: taskOwnerId, projectId: this.projectId.value });
        }
        showProjectDeleteModal() {
            this.machineService.send({ type: "DELETE_PROJECT" });
        }
        deleteProject() {
            this.machineService.send({ type: "DELETING_PROJECT", projectId: this.projectId });
        }
        cancelProjectDelete() {
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        ConfirmedProjectForTaskMoved() {
            this.validate("selectProjectForMovingTask").then((response) => {
                if (response) {
                    this.machineService.send({ type: "MOVING_TASK_TO_PROJECT", projectId: Guid.parse(this.selectedOwnedProject.id), taskId: this.taskId });
                    ProjectModule.clearProject();
                }
            });
        }
        //Lifecycle;
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
        created() {
            this.projectId = Guid.parse(this.$route.params.projectId);
            this.machineService.machine.context.projectId = this.projectId;
            this.machineService.machine.context.tagOperationPerformed = this.tagOperationPerformed.bind(this);
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("gettingDetails.gettingProjectDetails") || this.state.matches("projectLoaded") || this.state.matches("gettingDetails.gettingTaskDetails")) {
                    this.resetTagOperation();
                    this.$bvModal.hide("manage-tag");
                    this.$bvModal.hide("create-Task");
                    this.$bvModal.hide("change-Ownership");
                    this.$bvModal.hide("edit-project");
                    this.$bvModal.hide("edit-task");
                    this.$bvModal.hide("link-Parent-Project");
                    this.$bvModal.hide("add-subproject");
                    this.$bvModal.hide("add-link");
                    this.$bvModal.hide("edit-link");
                    this.$bvModal.hide("without-member");
                    this.$bvModal.hide("Convert-Task-To-Project");
                    this.$bvModal.hide("request-tracking");
                    this.$bvModal.hide("move-task-to-project");
                    this.$bvModal.hide("Restrict-Convert-Task-To-Project");
                    this.task = {
                        projectId: null,
                        taskName: null,
                        taskDescription: null,
                    };
                }
                if (this.state.matches("projectLoaded") && previousState.matches("addingSubProject")) {
                    this.project.name = "";
                    this.project.description = "";
                }
                if (this.state.matches("projectLoaded") && previousState.matches("movingTaskToProject")) {
                    this.selectedOwnedProject = null;
                    this.filteredProjects = [];
                }
                if (this.state.matches("projectLoaded") && previousState.matches("removingAsApexProject")) {
                    this.projectDetailEntries.isApexProject = false;
                }
                if (this.state.matches("projectLoaded") && previousState.matches("markingAsApexProject")) {
                    this.projectDetailEntries.isApexProject = true;
                }
                if (this.state.matches("projectLoaded") && previousState.matches("removingAsApexSubProject")) {
                    for (var i = 0; i < this.subProjects.length; i++) {
                        this.subProjects[i].isApexSubProject = false;
                    }
                }
                if (this.state.matches("projectLoaded") && previousState.matches("markingAsApexSubProject")) {
                    for (var i = 0; i < this.subProjects.length; i++) {
                        this.subProjects[i].isApexSubProject = true;
                    }
                }
                if (this.state.matches("assignTag") || this.state.matches("unassignTag")) {
                    this.$bvModal.show("manage-tag");
                }
                if (this.state.matches("creatingTask")) {
                    this.$bvModal.show("create-Task");
                }
                if (this.state.matches("changeOwnership")) {
                    if (this.projectDetailEntries.isOwner && this.projectDetailEntries.members.length > 1) {
                        this.$bvModal.show("change-Ownership");
                    }
                    else {
                        this.$bvModal.show("without-member");
                    }
                }
                if (this.state.matches("updateProject")) {
                    this.$bvModal.show("edit-project");
                }
                if (this.state.matches("editTask")) {
                    this.$bvModal.show("edit-task");
                }
                if (this.state.matches("linkWithParentProject")) {
                    this.$bvModal.show("link-Parent-Project");
                }
                if (this.state.matches("selectProjectForMovingTask")) {
                    this.$bvModal.show("move-task-to-project");
                }
                if (this.state.matches("addSubProject")) {
                    this.$bvModal.show("add-subproject");
                }
                if (this.state.matches("addLink")) {
                    this.link.name = "";
                    this.link.url = "";
                    this.$bvModal.show("add-link");
                }
                if (this.state.matches("editLink")) {
                    this.$bvModal.show("edit-link");
                }
                if (this.state.matches("gettingUser")) {
                    this.$bvModal.show("request-tracking");
                }
                if (this.state.matches("convertTaskToProject")) {
                    this.$bvModal.show("Convert-Task-To-Project");
                }
                if (this.state.matches("convertTaskToProject") && previousState.matches("convertTaskToProject")) {
                    this.projectDetail = [];
                    this.taskDetail = [];
                    this.selectedProject.isMainProject = true;
                    this.selectedProject.projectOwnerId = "";
                }
                if (this.state.matches("projectLoaded") && previousState.matches("requestingUserForLinkingProject")) {
                    this.requestedUser = null;
                }
                if (this.state.matches("addingEntryUnderTask") && previousState.matches("projectLoaded")) {
                    bus.$emit("cw_mini_running_state");
                }
                if (this.state.matches("projectLoaded") && previousState.matches("deletingProject")) {
                    const deletionResult = this.machineService.state.context.deletionResult;
                    if (deletionResult === "success") {
                        this.$router.push({ name: "Projects" });
                    }
                }
            });
        }
        beforeDestroy() {
            ProjectModule.ClearProjectDetails();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ProjectOverview = __decorate([
        Component({
            name: "ProjectOverview",
            components: {
                Loader,
                SectionLoader,
                Layout,
                PageHeader,
                BaseMixer,
                CredMixer,
                simplebar,
                EmployeeUserComponent,
                DeleteComponent,
                ProjectImpedimentComponent,
                SkeletonLoaderProjectOverview,
                MultiSelectComponent,
            },
        })
    ], ProjectOverview);
    return ProjectOverview;
})();
export default ProjectOverview;
